import React, { useEffect } from 'react';
import { useAuth } from '../../Auth/AuthProvider';
import LoadingPage from '../LoadingPage';
import { useTranslation } from 'react-i18next';

type Props = {
  component: JSX.Element;
};

const AuthenticationGuard: React.FC<Props> = ({ component }) => {
  const { isAuthenticated, isLoading, login } = useAuth();
  const {t} = useTranslation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [isLoading, isAuthenticated, login]);

  if (isLoading || !isAuthenticated) {
    return <LoadingPage message={t('common.msg_redirect_login')} />;
  }

  return component;
};

export default AuthenticationGuard;